export default __webpack_public_path__ + "static/media/lock-black.81f25257.svg";